import { makeRequest } from './Storefront'

const imageResponse = `
  altText
  height
  url
  width
  id
`
const variantResponse = `
  id
  availableForSale
  quantityAvailable
  sku
  selectedOptions { name value }
  price {
    amount
  }
  compareAtPrice {
    amount
  }
  image {
    ${imageResponse}
  }
`
const basicProductResponse = `
  id
  handle
  availableForSale
  options (first: 2) {
    name
    optionValues {
      name
    }
  }
  selectedOrFirstAvailableVariant {
    ${variantResponse}
  }
  sku: metafield(namespace: "custom", key: "sku") {
    value
  }
  ffid: metafield(namespace: "custom", key: "ffid") {
    value
  }
  customCTA: metafield(namespace: "custom", key: "custom_cta") {
    value
  }
  comingSoonUS: metafield(namespace: "tags", key: "coming_soon_us") {
    value
  }
  comingSoonROW: metafield(namespace: "tags", key: "coming_soon_row") {
    value
  }
`
const productResponse = `
  ${basicProductResponse}
  vendor
  title
  onlineStoreUrl
  featuredImage {
    ${imageResponse}
  }
  tags
  images (first: 10) {
    edges {
      node {
        ${imageResponse}
      }
    }
  }
  variants (first: 20) {
    edges {
      node {
        ${variantResponse}
      }
    }
  }
  style: metafield(namespace: "custom", key: "style") {
    value
  }
  privatePrice: metafield(namespace: "private_sale_price", key: "json") {
    value
  }
`
window.productResponse = productResponse

const collectionsResponse = `
  collections (first: 10) {
    edges {
      node {
        title
        products (first: 48) {
          edges {
            node {
              title,
              ${basicProductResponse}
            }
          }
        }
      }
    }
  }
`
window.collectionsResponse = collectionsResponse

export const getProductsBySkus = (callback = null, skus = []) => {
  console.log('skus', skus)
  const query = `query @inContext(country: ${Shopify.country}, language: ${Shopify.locale.toUpperCase()}) {
    products (first: 50, query: "${skus.join(' OR ')}" ) {
      edges {
        node {
          ${productResponse}
        }
      }
    }
  }`
  makeRequest((results) => {
    callback(results.data.products.edges)
  }, query)
}

export const getProductsByIds = (callback = null, ids = []) => {
  const query = `query @inContext(country: ${Shopify.country}, language: ${Shopify.locale.toUpperCase()}) {
    nodes(ids: [${ids.join(',')}]) {
      ...on Product {
        ${productResponse}
      }
    }
  }`
  makeRequest((results) => {
    callback(results.data.nodes)
  }, query)
}
